/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Invitetitle2Inputs */

const zh_organizationsettings_invitetitle2 = /** @type {(inputs: Organizationsettings_Invitetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请新成员`)
};

const en_organizationsettings_invitetitle2 = /** @type {(inputs: Organizationsettings_Invitetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite new members`)
};

const es_organizationsettings_invitetitle2 = /** @type {(inputs: Organizationsettings_Invitetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitar nuevos miembros`)
};

/**
* | output |
* | --- |
* | "Invite new members" |
*
* @param {Organizationsettings_Invitetitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_invitetitle2 = /** @type {((inputs?: Organizationsettings_Invitetitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Invitetitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_invitetitle2(inputs)
	if (locale === "en") return en_organizationsettings_invitetitle2(inputs)
	return es_organizationsettings_invitetitle2(inputs)
});
export { organizationsettings_invitetitle2 as "organizationSettings_inviteTitle" }